import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  colors,
  makeStyles,
  Grid
} from '@material-ui/core';

import { Doughnut } from 'react-chartjs-2';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56
  },
  differenceIcon: {
    color: colors.red[900]
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1)
  }
}));

const ShareAllocationPie = () => {
  const classes = useStyles();

  const topShareholdersAmount = [63, 15, 21, 3, 3, 3]
  const topShareholdersUsername = ['plasmatech8', 'blazar', 'Mr360', 'DrChocolate', 'Dude']

  const newShares = 23
  const totalShares = topShareholdersAmount.reduce((a, b) => a + b, 0)

  const data = {
    datasets: [
      {
        data: topShareholdersAmount,
        backgroundColor: [
          colors.indigo[500],
          colors.red[600],
          colors.orange[600],
          colors.purple[600],
          colors.green[600],

        ],
        borderWidth: 2,
        borderColor: colors.common.white,
        hoverBorderColor: colors.common.white
      }
    ],
    labels: topShareholdersUsername
  };


  return (
    <Card
      className={classes.root}
    >
      <CardContent>

      <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item xs={12}>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              Share Distribution
            </Typography>
          </Grid >
          <Grid item xs={12}>
          <Doughnut data={data}></Doughnut>
            <br/>
            <div>
              <Typography
                  color="textSecondary"
                  variant="caption"
                  >
                  {newShares} new shares issued last month
              </Typography>
            </div>
            <div>
              <Typography
                color="textSecondary"
                variant="caption"
                >
                {totalShares} total shares issued
              </Typography>
            </div>
          </Grid >
        </Grid>

      </CardContent>
    </Card>
  );
};

export default ShareAllocationPie;
